import { WorkOrderPriority } from "@/data_source/models/APIWorkOrder";

export type WorkOrderPriorityOption = {
  label: string;
  value: WorkOrderPriority;
};

export const WORK_ORDER_PRIORITY_OPTIONS: readonly WorkOrderPriorityOption[] = [
  { label: "No priority", value: WorkOrderPriority.None },
  { label: "Low", value: WorkOrderPriority.Low },
  { label: "Medium", value: WorkOrderPriority.Medium },
  { label: "High", value: WorkOrderPriority.High }
];

const WORK_ORDER_PRIORITY_VALUES = new Set<unknown>(
  WORK_ORDER_PRIORITY_OPTIONS.map(({ value }) => value)
);

export function isWorkOrderPriority(
  value: unknown
): value is WorkOrderPriority {
  return WORK_ORDER_PRIORITY_VALUES.has(value);
}
